module.exports = __webpack_public_path__ + "static/media/UnboxingDoodle.cae4f127.svg";